import { RectTransitionMode } from './types'

export const RECT_TRANSITION_MODES: readonly RectTransitionMode[] = [
    'reveal-up',
    'reveal-right',
    'reveal-down',
    'reveal-left',
    'center',
    'flow-up',
    'flow-right',
    'flow-down',
    'flow-left',
]
